export default __webpack_public_path__ + "static/media/gb-logo-linear-white.57087b7a.svg";